/* src/app/rt-components/file/file.component.scss */
:host {
  display: inline-block;
  margin: 0 4px 10px;
  position: relative;
}
:host .file {
  display: block;
  width: 120px;
}
:host .file .file-prev {
  background: rgba(93, 173, 224, 0.3);
  color: #fff;
  display: block;
  font-size: 40px;
  padding-top: 100%;
  position: relative;
  width: 100%;
}
:host .file .file-prev .icon {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
:host .file .file-prev .icon .delete {
  background: rgba(0, 0, 0, 0.1);
  font-size: 20px;
  position: absolute;
  right: 0;
  top: 0;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
}
.rtl :host .file .file-prev .icon .delete {
  left: 0;
  right: auto;
}
:host .file .file-prev .icon .delete:hover {
  background: rgba(255, 255, 255, 0.3);
  color: #f00;
}
:host .file .file-prev .spinner {
  background: inherit;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
:host .file .file-prev .spinner .fa {
  font-size: inherit;
}
:host .file .file-name {
  display: flex;
  flex-wrap: nowrap;
  font-size: 11px;
  justify-content: flex-end;
  margin-top: 3px;
  white-space: nowrap;
}
.rtl :host .file .file-name {
  justify-content: flex-start;
}
:host .file .file-name .name {
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .file.doc-file .file-prev {
  background: #029acf;
}
:host .file.xlx-file .file-prev {
  background: #469408;
}
:host .file.pdf-file .file-prev {
  background: #d9831f;
}
:host .file.archive-file .file-prev {
  background: #9b479f;
}
:host .file.audio-file .file-prev {
  background: #FF9800;
}
:host .file.video-file .file-prev {
  background: #FF5722;
}
:host .file.image-file .file-prev .icon {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
:host .file.size-small {
  width: 50px;
}
:host .file.size-small .file-prev {
  font-size: 20px;
}
:host .file.size-large {
  width: 180px;
}
:host .file.size-large .file-prev {
  font-size: 60px;
}
:host .file.spinner-file .file-prev .icon {
  visibility: hidden;
}
/*# sourceMappingURL=file.component.css.map */
